const retryPromise = (promiseFn, onRetryScheduled, onRetrySucceeded) =>
  new Promise(resolve => {
    const maxRetries = 5;
    const timeout = 5 * 1000; // wait 5 seconds between retries
    let retries = 0;
    const retry = () => {
      promiseFn()
        .then(result => {
          if (retries > 0) {
            onRetrySucceeded();
          }
          resolve(result);
        })
        .catch(() => {
          onRetryScheduled(timeout);
          if (retries < maxRetries) {
            retries += 1;
            setTimeout(retry, timeout);
          }
        });
    };
    retry();
  });

export default retryPromise;



// WEBPACK FOOTER //
// ../utils/functions/retry-promise.js